import {Typography} from '@material-ui/core';
import React from 'react';
import './style.js';
import resumeData from "../../utils/resumeDate"
import useStyles from './style.js';

const Footer = () => {

  const classes = useStyles()

  return (
    <div className={classes.footer}>
      <div className={classes.footerLeft}>
          <Typography className={classes.footerName}>© 2021 All rights reserved </Typography>
      </div>
      <div className={classes.footerRight}>
        <Typography className={classes.footerCopyright}>
          Designed and Developed by <a className={classes.a} href="/" target="_blank"> Smit Shah</a>
        </Typography>
      </div>
    </div>
  );
};

export default Footer;
